<template>
  <form
    class="resetPwd-form"
    data-akt="reset-password-form"
    @submit.prevent="submit"
  >
    <div class="header">
      <AkHeading3>
        {{ $t('resetPassword.title') }}
      </AkHeading3>
      <AkParagraph v-if="errorMessage === ''">
        {{ $t('resetPassword.subTitle') }}
      </AkParagraph>
      <AkParagraph v-else>
        {{ $t('resetPassword.subTitle.sent') }}
      </AkParagraph>
    </div>

    <div class="content">
      <div
        v-if="successMessage"
        class="reset-succes"
        data-testid="reset-password-success"
      >
        {{ successMessage }}
      </div>

      <div
        v-else
      >
        <AkInput
          id="email"
          v-model="email"
          class="resetPwd-form__input"
          type="email"
          name="email"
          autocomplete="username"
          :placeholder="$t('loginForm.adressPlaceholder')"
          required
          data-testid="reset-password-email-input"
          :label="$t('loginForm.adressLabel')"
        />
        <div
          v-if="errorMessage"
          class="global-error"
          data-testid="reset-password-error"
        >
          {{ errorMessage }}
        </div>

        <AkButton
          class="button--extended ds-mt-3"
          type="submit"
          size="xl"
          data-testid="reset-password-submit-button"
        >
          {{ $t('Send') }}
        </AkButton>
      </div>
    </div>

    <div class="footer">
      <AkButton
        link
        @click.prevent="$emit('change-to-login')"
      >
        {{ $t('loginForm.backToLogin') }}
      </AkButton>
    </div>
  </form>
</template>

<script lang="ts">
import { AkButton, AkHeading3 } from '@ankorstore/design-system';
import { defineComponent } from 'vue';
import http from '@monolith/legacy/services/api/http';

export default defineComponent({
  name: 'ResetPasswordForm',
  components: { AkButton, AkHeading3 },
  emits: ['change-to-login'],
  data: () => {
    return {
      email: '',
      successMessage: '',
      errorMessage: '',
    };
  },
  methods: {
    submit() {
      this.$store.commit('SET_PROGRESS_BAR_STATE', 'loading');
      this.errorMessage = '';

      http()
        .post('/password/email', {
          email: this.email,
        })
        .then((response) => {
          this.successMessage = response.data.message;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message && error.success) {
            this.errorMessage = error.response.data.message;
          } else {
            this.errorMessage = this.$t('ResetPasswordForm.error.generic');
          }
        })
        .finally(() => {
          this.$store.commit('SET_PROGRESS_BAR_STATE', 'ending');
        });
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@css/vue-import';
.footer {
  @apply ds-flex ds-justify-center;
}
.resetPwd-form {
  .header {
    @apply ds-mb-5;
  }
  .global-error {
    @apply ds-mb-4 ds-text-center;
  }
  &__input {
    @apply ds-mb-8;
  }
}
</style>
